import { Component, Prop, JSX } from '@stencil/core';
import { store } from 'app/shared/store/store';
import { AddressDetailModel, Context } from 'app/shared/models/index';
import { localStorageService } from 'app/shared/services/local-storage/local-storage.service';
import { StoreKeys } from 'app/shared/constants/store-keys.enum';

@Component({
  tag: 'product-comparison-container',
  shadow: false
})
export class ProductComparisonContainer {
  @Prop() public didRenderFunc: () => void;
  @Prop() public renderFunc: (context: Context) => JSX.Element;

  private onAddressChange(address: AddressDetailModel): void {
    store.set('address', address);
    localStorageService.setRegion(address.state);
    store.set('showValidIcon', true);

    const validationErrors: Error[] = store.get('validationErrors');
    const updatedErrors: Error[] = validationErrors && {
      ...validationErrors.filter((e: Error) => {
        return e.name !== 'address';
      })
    };

    if (updatedErrors?.length > 0) {
      store.set('showValidIcon', false);
    }

    store.set('validationErrors', updatedErrors);
  }

  public componentDidRender(): void {
    if (this.didRenderFunc) {
      this.didRenderFunc();
    }
  }

  render(): JSX.Element {
    return this.renderFunc({
      productDetails: store.get(StoreKeys.productDetails),
      configData: store.get('configData'),
      validationErrors: store.get('validationErrors'),
      onAddressChange: (address: AddressDetailModel) => this.onAddressChange(address),
      responseError: store.get('responseError'),
      selectedAddress: store.get('address'),
      isExplicitBundleFlow: store.get('isExplicitBundleFlow'),
      isPersonalisedProductsLoading: store.get('isPersonalisedProductsLoading'),
      delayMessage: store.get('delayMessage'),
      isPageLoaded: store.get('isPageLoaded'),
      productCategory: store.get(StoreKeys.productCategory),
      showValidIcon: store.get('showValidIcon')
    });
  }
}
